import { Text } from "@chakra-ui/react";

import { AudienceCountUnavailable } from "@/common/components/AudienceCountUnavailable";
import MotionBox from "@/common/components/MotionBox";
import { formatNumber } from "@/common/utils/numberFormatting";
import type { SegmentViewType } from "@/company/components/SegmentViewToggle";
import type { SegmentAudienceCountState } from "@/company/hooks/useSegmentAudienceCount";
import pluralize from "@reflag/shared/utils/pluralize";

type Props = {
  audienceCount: SegmentAudienceCountState;
  viewType: SegmentViewType;
};

const motionProps = {
  animate: { opacity: 1 },
  display: "flex",
  gap: 4,
  initial: { opacity: 0 },
  transition: { type: "ease", duration: "0.1" },
} as const;

export function SegmentAudienceCountIndicator({
  audienceCount,
  viewType,
}: Props) {
  if (audienceCount.status === "loading") {
    return null;
  }

  if (audienceCount.status === "unavailable") {
    return (
      <MotionBox {...motionProps}>
        <AudienceCountUnavailable />
      </MotionBox>
    );
  }

  if (audienceCount.status === "error") {
    return (
      <MotionBox {...motionProps}>
        <Text fontSize="sm" fontWeight="normal" variant="dimmed">
          Count unavailable
        </Text>
      </MotionBox>
    );
  }

  const totalCount = audienceCount.displayedTotalCount;
  if (totalCount === undefined) return null;

  return (
    <MotionBox {...motionProps}>
      <Text fontSize="sm" fontWeight="normal" variant="dimmed">
        {formatNumber(totalCount)}{" "}
        {pluralize(viewType === "companies" ? "company" : "user", totalCount)}
      </Text>
    </MotionBox>
  );
}
